/**
 * NAZWA KLIENTA ZGADYWANA Z ADRESU INSTANCJI — wyłącznie jako WYPEŁNIENIE POLA do zaakceptowania.
 *
 * ⚠️ ISTNIEJE PO TO, ŻEBY PIERWSZE POLE NIE BYŁO PUSTE. Instancje wydaje platforma pod adresem
 * `vendi.<klient>.ergoflow.app`, więc nazwa klienta stoi w adresie, na który technik właśnie patrzy
 * — a mimo to musiał wpisywać ją z klawiatury. Wartość jest PODPOWIEDZIĄ w edytowalnym polu, nigdy
 * nie idzie do bazy bez potwierdzenia człowiekiem: adres bywa tymczasowy (staging, IP, port),
 * a nazwa wyspy pokazuje się potem klientowi w portalu i w raportach.
 *
 * ⚠️ WOLIMY NIE ZGADYWAĆ, NIŻ ZGADNĄĆ ŹLE. `null` znaczy „z tego adresu nic sensownego nie wynika"
 * i wtedy ekran sięga po nazwę klienta z bazy. Adres bez poddomeny klienta (`vendi.ergoflow.app`),
 * `localhost` i adresy IP dają właśnie `null` — bo „Ergoflow" ani „Localhost" nie są nazwą obiektu
 * u klienta, a wpisana raz zostaje w danych na lata.
 */

/** Członów, które opisują NASZ produkt albo środowisko, nie klienta. */
const PRODUKTOWE = new Set(['vendi', 'portal', 'panel', 'app', 'www', 'instancja', 'test', 'dev', 'staging']);

const CZY_IP = /^\d{1,3}(\.\d{1,3}){3}$/;

/** `zaklad-pila` → `Zaklad Pila`; pojedyncze słowo dostaje samą wielką literę. */
function ładnaNazwa(czlon: string): string {
  return czlon
    .split(/[-_]+/)
    .filter((s) => s.length > 0)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}

export function nazwaZAdresu(hostname: string | undefined): string | null {
  const host = (hostname ?? '').trim().toLowerCase().replace(/\.$/, '');
  if (host === '' || CZY_IP.test(host)) return null;

  const czlony = host.split('.').filter((c) => c.length > 0);
  if (czlony.length < 2) return null;

  /** Zdejmujemy nasze przedrostki, ale nigdy poniżej „domena + końcówka". */
  let scieto = false;
  while (czlony.length > 2 && PRODUKTOWE.has(czlony[0]!)) {
    czlony.shift();
    scieto = true;
  }

  /**
   * Po ścięciu przedrostka zostały tylko domena i końcówka — czyli w adresie NIE BYŁO poddomeny
   * klienta (`vendi.ergoflow.app`). Nazwą klienta nie jest nasza domena, więc nie zgadujemy.
   */
  if (scieto && czlony.length <= 2) return null;

  const kandydat = czlony[0]!;
  if (PRODUKTOWE.has(kandydat)) return null;
  return ładnaNazwa(kandydat);
}
